var pageHeader = document.querySelector('.main__wrap .page-header--featured-block');
var latestBlock = document.querySelector('.main__wrap > :nth-child(3)');

if ( pageHeader ) {
    var latestBlock = document.querySelector('.main__wrap > :nth-child(3)');
    latestBlock.classList.add( 'latest-block--pullup' );
}